import { render, staticRenderFns } from "./ProseccoContent.vue?vue&type=template&id=15adfcdc&scoped=true&"
import script from "./ProseccoContent.vue?vue&type=script&lang=js&"
export * from "./ProseccoContent.vue?vue&type=script&lang=js&"
import style0 from "./ProseccoContent.vue?vue&type=style&index=0&id=15adfcdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15adfcdc",
  null
  
)

export default component.exports